import GradeForm from "../../components/Forms/GradeForm";
import MainGoal from "../../components/Forms/MainGoal";
import BasicCard from "../BasicCard";

import Dummylayout from "../Dummylayout";

function GradeFormmain() {
    return (
        <>
        {/* <MainLayout/> */}
           <div> <Dummylayout/></div>
    
<div className="mx-5 pl-5">
            <BasicCard>
                <GradeForm/>
               
            </BasicCard>
            </div>
        </>
    )
}
export default GradeFormmain;